export default __webpack_public_path__ + "static/media/kloudless.1c0b3a74.svg";